export const getDefaultSelectValue = () => {
  return (
    document.querySelector('[data-select-first-option-text]')?.dataset?.selectFirstOptionText ||
    'Select'
  );
};

// Plain default Datepicker setup - a fixed fallback format, used only when
// no Sitecore-driven date format (ShortDateFormat)
export const getDefaultDatepickerSetup = () => {
  const currentYear = new Date().getFullYear();

  return {
    minDate: null,
    maxDate: null,
    format: 'DD-MM-YY',
    dateRange: 0,
    yearRange: [currentYear - 5, currentYear + 5],
    preventDefault: true,
    disableWeekends: false,
    disableDays: null,
  };
};
